import { requestGlobalSettingData } from "../../../apis";
import localStorageKey from "../../../enumerations/localStorageKey";

const currency =
  window.localStorage.getItem(localStorageKey.DEFAULT_CURRENCY) ||
  process.env.REACT_APP_DEFAULT_CURRENCY;

export const apiUpdateRecentPlayGameStatus = (params) =>
  requestGlobalSettingData("put", `/${currency}/game/status/check`, params, false, true);
